module.exports = __webpack_public_path__ + "img/58.9.TU.901828c4.png";